'use client';

import { useState, useEffect, PropsWithChildren } from 'react';

/**
 * A wrapper component to ensure content is only rendered client-side
 * 
 * This prevents hydration issues with components that rely on browser APIs
 * or must be client-side only (like Firebase-dependent components)
 */
export default function ClientOnly({ children }: PropsWithChildren<{}>) {
  const [hasMounted, setHasMounted] = useState(false);

  // Only show content after component has mounted on the client
  useEffect(() => {
    setHasMounted(true);
  }, []);

  // If the component hasn't mounted yet, render nothing (prevent SSR)
  if (!hasMounted) {
    return null;
  }

  // Otherwise, render children normally
  return <>{children}</>;
} 